// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"72885acf","732":"83bce395","977":"565967a4"}[chunkId] + ".chunk.js";
};